import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Link, Button, TextField, CircularProgress, Checkbox, FormControlLabel, FormControl, Select, MenuItem
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import AddUserDialog from '../users/AddUserDialog';
import AddSubscriptionDialog from '../subscriptions/AddSubscriptionDialog';
import OndemandWashDialog from '../subscriptions/OndemandWashDialog';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import WasherOptions from '../../common/components/WasherOptions';

const RequestList = () => {
  const [requests, setRequests] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [userDialogOpen, setUserDialogOpen] = useState(false);
  const [userDialogData, setUserDialogData] = useState(null);
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  const [subscriptionDialogUser, setSubscriptionDialogUser] = useState(null);
  const [ondemandDialogOpen, setOndemandDialogOpen] = useState(false);
  const [ondemandDialogUser, setOndemandDialogUser] = useState(null);
  const [copied, setCopied] = useState(null);

  const [assignFormRowId, setAssignFormRowId] = useState(null);
  const [dateTime, setDateTime] = useState('');
  const [washerList, setWasherList] = useState([]);
  const [washerQuery, setWasherQuery] = useState('');
  const [washerLoading, setWasherLoading] = useState(false);
  const [selectedWasher, setSelectedWasher] = useState(null);
  const [price, setPrice] = useState('');
  const [paid, setPaid] = useState(false);
  const [transaction, setTransaction] = useState('');
  const [washType, setWashType] = useState('');

  // useEffect(() => {
  //   const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
  //   fetch(`${process.env.REACT_APP_SERVER_URI}/requests/notification/clear`, {
  //     headers: {
  //       Authorization: token ? `Bearer ${token}` : '',
  //     },
  //   })
  //     .then(res => res.json())
  //     .then(result => {})
  //     .catch(() => {});
  // }, []);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/requests/list?page=${page + 1}&limit=${rowsPerPage}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(result => {
        setRequests(result.data || []);
        setTotal(result.total || 0);
      })
      .catch(() => {
        setRequests([]);
        setTotal(0);
      });
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate = (dateInput) => {
    if (!dateInput) return '-';
    const iso = typeof dateInput === 'object' && dateInput.$date ? dateInput.$date : dateInput;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '-';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return `${day}-${month}-${year} ${time}`;
  };

  const formatDecimalTime = (timeInput) => {
    if (timeInput == null || timeInput === '') return '-';
    const s = String(timeInput);
    const [hPart, mPartRaw] = s.split('.');
    const h = parseInt(hPart, 10);
    if (Number.isNaN(h)) return '-';
    let m = 0;
    if (mPartRaw !== undefined) {
      const mStr = mPartRaw.padEnd(2, '0').slice(0, 2);
      m = parseInt(mStr, 10);
      if (Number.isNaN(m)) m = 0;
    }
    const d = new Date();
    d.setHours(h);
    d.setMinutes(m);
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  };

  const handleOpenUserDialog = (req) => {
    setUserDialogData({
        _id: req.userId || '',
        name: req.name || '',
        email: req.email || '',
        phone: req.phone || '',
        cars: [{
            model: req.carModel || (req.cars && req.cars[0]?.model) || '',
            carName: req.carName || (req.cars && req.cars[0]?.name) || '',
            regNo: req.carRegNo || (req.cars && req.cars[0]?.regNo) || ''
        }],
        requestId: req._id || null
    });
    setUserDialogOpen(true);
  };

  const handleOpenSubscriptionDialog = (req) => {
    setSubscriptionDialogUser({
      userId: req.userId,
      name: req.name,
      phone: req.phone,
      car: req.cars && req.cars[0] ? req.cars[0] : {
        model: req.carModel || '',
        carName: req.carName || '',
        regNo: req.carRegNo || ''
      }
    });
    setSubscriptionDialogOpen(req._id);
  };

  const handleOpenOndemandDialog = (req) => {
    setOndemandDialogUser({
      userId: req.userId,
      name: req.name,
      phone: req.phone,
      car: req.cars && req.cars[0] ? req.cars[0] : {
        model: req.carModel || '',
        carName: req.carName || '',
        regNo: req.carRegNo || ''
      }
    });
    setOndemandDialogOpen(true);
  };

  const handleClosed = (requestId) => {
    if (!window.confirm('Are you sure you want to close this request?')) return;
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/requests/close/${requestId}`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(() => {
        setRequests(requests => requests.filter(r => r._id !== requestId));
        setTotal(t => t - 1);
      })
      .catch(() => {
        alert('Failed to delete request.');
      });
  };

   const handleDelete = (requestId) => {
    if (!window.confirm('Are you sure you want to close this request?')) return;
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/requests/delete/${requestId}`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(() => {
        setRequests(requests => requests.filter(r => r._id !== requestId));
        setTotal(t => t - 1);
      })
      .catch(() => {
        alert('Failed to delete request.');
      });
  };

  const handleCopy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(null), 1200);
  };

  const handleWasherInputChange = (event, value) => {
    setWasherQuery(value || '');
    setSelectedWasher(null);
    if (!value) {
      setWasherList([]);
      return;
    }
    setWasherLoading(true);
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/washers/search?query=${encodeURIComponent(value)}`, {
      headers: { Authorization: token ? `Bearer ${token}` : '' }
    })
      .then(res => res.json())
      .then(res => setWasherList(res.data || []))
      .catch(() => setWasherList([]))
      .finally(() => setWasherLoading(false));
  };

  const handleAssignLampClick = (req) => {
    setAssignFormRowId(req._id);
    setDateTime('');
    setSelectedWasher(null);
    setWasherQuery('');
    setPrice('');
    setPaid(false);
    setTransaction('');
  };

  const handleAssignCancel = () => {
    setAssignFormRowId(null);
    setDateTime('');
    setSelectedWasher(null);
    setWasherQuery('');
    setPrice('');
    setPaid(false);
    setTransaction('');
  };

  const handleAssignSubmit = (req) => {
    if (!dateTime || (!selectedWasher && !washerQuery) || !price) {
      alert('Please fill date/time, washer and price.');
      return;
    }
    if (paid && !transaction) {
      alert('Please enter transaction details when marked as paid.');
      return;
    }
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    const washerIdOrName = selectedWasher ? (selectedWasher._id || selectedWasher.id || selectedWasher.name) : washerQuery;
    // try to infer carId from the request if no separate selectedCar exists
    const carId = req.carId;

    if (req.requestType === 'wash'|| req.requestType === 'free-wash') {
      // Split dateTime into a Date object for the backend (as requested)
      const date = dateTime? new Date(dateTime) : new Date();
      fetch(`${process.env.REACT_APP_SERVER_URI}/washes/ondemand`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
        body: JSON.stringify({
          date,
          washerId: selectedWasher._id || selectedWasher.id,
          carId,
          price:req.requestType === 'free-wash'? 0 : price,
          paid,
          transaction: transaction,
          requestId: req._id,
          isFreeWash: req.requestType === 'free-wash',
        }),
      })
        .then(res => res.json())
        .then(() => {
          // reset form
          handleAssignCancel();
          setPage(p => p);
        })
        .catch(() => {
          alert('Failed to add ondemand wash.');
        });
      return;
    }

    const payload = {
      dateTime,
      assignee: washerIdOrName,
      price,
      transactionId: transaction || undefined
    };
    fetch(`${process.env.REACT_APP_SERVER_URI}/request/updateAssignee/${req._id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(() => {
        handleAssignCancel();
        setPage(p => p);
      })
      .catch(() => {
        alert('Failed to assign LAMP.');
      });
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>Request List</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={3} align="left" sx={{ fontWeight: 600, background: '#f5f5f5' }}>Type</TableCell>
              <TableCell colSpan={3} align="left" sx={{ fontWeight: 600, background: '#f5f5f5' }}>User</TableCell>
              <TableCell colSpan={3} align="left" sx={{ fontWeight: 600, background: '#f5f5f5' }}>Car</TableCell>
              <TableCell colSpan={4} align="left" sx={{ fontWeight: 600, background: '#f5f5f5' }}>Details</TableCell>
              <TableCell colSpan={4} align="left" sx={{ fontWeight: 600, background: '#f5f5f5' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {requests.map((req) => (
              <TableRow key={req._id}>
                <TableCell colSpan={3} align="left" sx={{ fontWeight: 600, background: '#f5f5f5' }}>
                  Type: {req.requestType || '-'}<br />
                  {Boolean(req.requestType === 'wash') &&<>
                    WashType: {req.isOnDemand ? 'On-Demand' : 'Subscription'}
                  </>} <br />
                  {req.requestType === 'sos' && <>Emergency: {req.emergency || '-'}</>}
                </TableCell>
                <TableCell colSpan={3} align="flex-start" sx={{ fontWeight: 600, background: '#f5f5f5' }}>
                  name: {req.name || '-'}<br />
                  address: {req.address || '-'} <br />
                  phone: {req.phone || '-'}<br />
                </TableCell>
                <TableCell colSpan={3} align="flex-start" sx={{ fontWeight: 600, background: '#f5f5f5' }}>
                  model: {req.carModel || (req.cars && req.cars[0]?.model) || '-'}<br/>
                  carName: {req.carName || (req.cars && req.cars[0]?.name) || '-'} <br/>
                  carRegNo: {req.carRegNo || (req.cars && req.cars[0]?.regNo) || '-'}<br/>
                </TableCell>
                <TableCell colSpan={4} align="flex-start" sx={{ fontWeight: 600, background: '#f5f5f5', position: 'relative', lineBreak: 'anywhere' }}>
                  requestTime: {req.createdAt ? formatDate(req.createdAt) : '-'} <br/>
                  location: {req.location || '-'} <br/>
                  exterior: {req.exterior || '-'} <br/>
                  interior: {req.interior || '-'} <br/>
                  {Array.isArray(req.interiorDays) && req.interiorDays.length > 0 && (
                    <>
                      interiorDays: {req.interiorDays.join(', ')} <br/>
                    </>
                  )}
                  {Array.isArray(req.selectedSchedules) && req.selectedSchedules.length > 0 && (
                    <>
                      selectedSchedules:
                      {req.selectedSchedules.map((sch, i) => (
                        <Box key={i} component="span" sx={{ display: 'block', ml: 1 }}>
                          - {formatDecimalTime(sch.startTime || '')} to {formatDecimalTime(sch.endTime || '')} ({Array.isArray(sch.days) ? sch.days.join(', ') : '-'})
                        </Box>
                      ))}
                    </>
                  )}
                  googleMapsUrl: {req.googleMapsUrl
                    ? (
                        <>
                          <Link href={req.googleMapsUrl} target="_blank" rel="noopener">Map</Link>
                          <Tooltip title={copied === req._id + '-url' ? 'Copied!' : 'Copy'}>
                            <ContentCopyIcon
                              fontSize="small"
                              sx={{ ml: 1, cursor: 'pointer', verticalAlign: 'middle' }}
                              onClick={() => handleCopy(req.googleMapsUrl, req._id + '-url')}
                            />
                          </Tooltip>
                        </>
                      )
                    : (Array.isArray(req.gps) && req.gps.length === 2
                        ? (
                            <>
                              <Link
                                href={`https://maps.google.com/?q=${req.gps[0]},${req.gps[1]}`}
                                target="_blank"
                                rel="noopener"
                              >
                                Map (GPS)
                              </Link>
                              <Tooltip title={copied === req._id + '-gps' ? 'Copied!' : 'Copy'}>
                                <ContentCopyIcon
                                  fontSize="small"
                                  sx={{ ml: 1, cursor: 'pointer', verticalAlign: 'middle' }}
                                  onClick={() => handleCopy(`https://maps.google.com/?q=${req.gps[0]},${req.gps[1]}`, req._id + '-gps')}
                                />
                              </Tooltip>
                            </>
                          )
                        : '-')
                  } <br/>
                </TableCell>
                <TableCell colSpan={4} align="right" sx={{ position: 'relative' }}>
                  {assignFormRowId === req._id ? (
                      <Box sx={{ p: 1, border: '1px solid rgba(0,0,0,0.08)', borderRadius: 1, bgcolor: 'background.paper' }}>
                        {['wash','free-wash'].includes(req.requestType) && <FormControl fullWidth sx={{ mt: 2 }}>
                                <Select
                                  value={washType}
                                  onChange={(e) => setWashType(e.target.value)}
                                  displayEmpty
                                  renderValue={(v) => (v ? v : "Select wash type (optional)")}
                                  MenuProps={{
                                    PaperProps: { sx: { bgcolor: "#23282e", color: "white", zIndex: 11000 } },
                                    MenuListProps: { sx: { bgcolor: "#23282e", zIndex: 11000 } },
                                  }}
                                  sx={{
                                    backgroundColor: "transparent",
                                    borderRadius: 1,
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    ".MuiSelect-select": { paddingTop: "10px", paddingBottom: "10px" },
                                  }}
                                >
                                  <MenuItem value="" disabled>Select wash type (optional)</MenuItem>
                                  <MenuItem value="waterless" sx={{ color: "white" }}>Waterless car wash</MenuItem>
                                  <MenuItem value="bucket" sx={{ color: "white" }}>Water Wash (Bucket wash)</MenuItem>
                                  <MenuItem value="jet-pressure" sx={{ color: "white" }}>
                                    Jet Pressure wash
                                  </MenuItem>
                                </Select>
                              </FormControl>}
                        <Box display="flex" alignItems="center" mb={1}>
                          <input
                            type="checkbox"
                            id={`immediately-checkbox-${req._id}`}
                            style={{ marginRight: 8 }}
                            checked={dateTime === ''}
                            onChange={e => setDateTime(e.target.checked ? '' : new Date().toISOString().slice(0,16))}
                          />
                          <label htmlFor={`immediately-checkbox-${req._id}`}>Immediately</label>
                        </Box>
                        {dateTime !== '' && (
                          <TextField
                            label="Date & Time"
                            type="datetime-local"
                            value={dateTime}
                            onChange={e => setDateTime(e.target.value)}
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                          />
                        )}
                        <WasherOptions
                          value={selectedWasher}
                          setValue={setSelectedWasher}
                          label="Select LAMP"
                          freeSolo
                          required
                          size="small"
                          fullWidth
                        />
                        <TextField
                          label="Price"
                          value={price}
                          // disabled={req.requestType === 'free-wash'}
                          onChange={e => setPrice(e.target.value)}
                          fullWidth
                          margin="normal"
                          size="small"
                          required
                        />
                        <Box display="flex" gap={1} alignItems="center" sx={{ mt: 1 }}>
                          <FormControlLabel
                            control={<Checkbox checked={paid} onChange={e => setPaid(e.target.checked)} />}
                            label="Paid"
                            sx={{ m: 0 }}
                          />
                          {paid && (
                            <TextField
                              label="Transaction"
                              value={transaction}
                              onChange={e => setTransaction(e.target.value)}
                              margin="normal"
                              size="small"
                              required
                              sx={{ flex: 1, minWidth: 180 }}
                            />
                          )}
                        </Box>
                        <Box display="flex" gap={1} justifyContent="flex-end" mt={1}>
                          <Button size="small" onClick={handleAssignCancel}>Cancel</Button>
                          <Button size="small" variant="contained" onClick={() => handleAssignSubmit(req)}>Save</Button>
                        </Box>
                      </Box>
                    ) : 
                     subscriptionDialogOpen === req._id ? <AddSubscriptionDialog
                        open={subscriptionDialogOpen}
                        carId={req.carId}
                        onClose={() => setSubscriptionDialogOpen('')}
                        user={Boolean(subscriptionDialogUser)}
                        onUserAdded={() => setSubscriptionDialogOpen('')}
                      />
                    :(
                  <Box sx={{
                    top: 8,
                    right: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                  }}>
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={() => handleOpenUserDialog(req)}
                    >
                      {req.userId ? 'Edit' : 'Create'} User
                    </Button>
                    {(req.requestType === 'wash' && !req.isOnDemand) ?
                      <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        disabled={!req.userId}
                        onClick={() => handleOpenSubscriptionDialog(req)}
                      >
                        Create subscription
                      </Button> :
                      <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        disabled={!req.userId}
                        onClick={() => handleAssignLampClick(req)}
                      >
                        Assign a LAMP
                      </Button>}
                    <Button
                      variant="outlined"
                      size="small"
                      color="error"
                      onClick={() => handleDelete(req._id)}
                    >
                        Delete
                    </Button>
                  </Box>
                    )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </TableContainer>
      <AddUserDialog
        open={userDialogOpen}
        onClose={() => setUserDialogOpen(false)}
        user={userDialogData}
        onUserAdded={() => setUserDialogOpen(false)}
      />
    </Box>
  );
};

export default RequestList;

